
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1337Dialog extends Serenity.EntityDialog<Report_1337Row, any> {
        protected getFormKey() { return Report_1337Form.formKey; }
        protected getIdProperty() { return Report_1337Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1337Row.localTextPrefix; }
        protected getNameProperty() { return Report_1337Row.nameProperty; }
        protected getService() { return Report_1337Service.baseUrl; }
        protected getDeletePermission() { return Report_1337Row.deletePermission; }
        protected getInsertPermission() { return Report_1337Row.insertPermission; }
        protected getUpdatePermission() { return Report_1337Row.updatePermission; }

        protected form = new Report_1337Form(this.idPrefix);

    }
}